// invoice-notifications.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InvoiceNotification, NotificationStats } from './invoice-notification.model';

@Injectable({
  providedIn: 'root'
})
export class InvoiceNotificationsService {

  private baseUrl = 'https://forecast.dentalpro.it/api/notifications';

  constructor(private http: HttpClient) {}

  getAll(filters?: {
    status?: string;
    type?: string;
    from?: string;
    to?: string;
    recipient?: string;
    supplier?: string;
  }): Observable<InvoiceNotification[]> {
    let params = new HttpParams();
    if (filters) {
      if (filters.status)   { params = params.set('status',   filters.status);   }
      if (filters.type)     { params = params.set('type',     filters.type);     }
      if (filters.from)     { params = params.set('from',     filters.from);     }
      if (filters.to)       { params = params.set('to',       filters.to);       }
      if (filters.recipient){ params = params.set('recipient',filters.recipient);}
      if (filters.supplier) { params = params.set('supplier', filters.supplier); }
    }
    return this.http.get<InvoiceNotification[]>(this.baseUrl, { params });
  }

  getStats(): Observable<NotificationStats> {
    return this.http.get<NotificationStats>(`${this.baseUrl}/stats`);
  }
}
